import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { name } from "../config/name.js";
const adapter = createEntityAdapter();
const initialState = adapter.getInitialState();
const slice = createSlice({
  name,
  initialState,
  reducers: {
    reset: () => initialState,
    setOne: adapter.setOne,
    removeOne: adapter.removeOne,
    upsertOne: adapter.upsertOne
  }
});
const { reducer, actions, reducerPath } = slice;
const selectors = adapter.getSelectors();
export {
  actions,
  adapter,
  reducer,
  reducerPath,
  selectors,
  slice
};
